import React from 'react'
import { batch } from '@preact/signals-react'

import { AppLengthOfRentalAutocomplete } from '@components'
import { BACKEND_APIS } from '@constants'
import { disableButton, errors, lengthRental } from '@signals'


export default function AppCommonFiltersLengthOfRentalAutocomplete({ ...props }) {
	return <AppLengthOfRentalAutocomplete
		multiple={false}
		value={lengthRental.value}
		error={errors.value?.lor}
		onChange={e => lengthRental.value = e.target.value}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/lors`}
		onFinishAjax={options => batch(() => {
			disableButton.value = false
			if (props.multiple && !lengthRental.value?.length) {
				lengthRental.value = [options[0]?.value]
			} else if (!lengthRental.value?.length) {
				lengthRental.value = options[0]?.value
			}
		})}
		{...props}
	/>
}